export default __webpack_public_path__ + "static/media/1798.d3b98fa4.png";